import { Badge, Flex, Image, Label } from "@aws-amplify/ui-react";
import { useTranslation } from "react-i18next";
import PlaceDataUtils from "../../utils/PlaceDataUtils";

interface PlaceCategoryBadgeProps {
    categoryEnum: string;
}

const PlaceCategoryBadge: React.FC<PlaceCategoryBadgeProps> = ({ categoryEnum }) => {
    const { t } = useTranslation();

    return (
        <Badge
            key={categoryEnum}
            id={categoryEnum}
            size="large"
            className="noselect place-category-badge nopointer"
        >
            <Flex>
                <Image
                    alt=""
                    objectFit="none"
                    src={PlaceDataUtils.getPlaceCategoryDetail(categoryEnum)?.iconPath}
                />
                <Label whiteSpace="nowrap">
                    {t('place.categories.' + categoryEnum)}
                </Label>
            </Flex>
        </Badge>
    );
};

export default PlaceCategoryBadge; 